import { render, staticRenderFns } from "./FormRadioGroup.vue?vue&type=template&id=6b848b36&"
import script from "./FormRadioGroup.vue?vue&type=script&lang=ts&"
export * from "./FormRadioGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports